


















import Vue from "vue";
import AppDialog from "~/components/AppDialog.vue";

export default Vue.extend({
  components: {
    AppDialog
  },
  props: ['center', 'user'],
  data: () => ({
    email: ''
  }),
  methods: {
    isEmailValid(email: string) {
      return !email || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
    },
    async handleSend() {
      let payload = {
        email: this.email,
        center: this.center,
        recievingUser: undefined,
        sendingUser: this.user,
      }

      try {
        await this.$axios.post(`user-invite/`, payload)
        this.email = '';
        this.$emit("added");
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
    }
  }
})
